import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import 'rxjs/Rx';
import { Router, NavigationEnd } from '@angular/router';
import { version } from './../../environments/environment.prod';
import { apiEndpoint } from './../../environments/environment';
import { UPDATE_ROUTES, SAVE_ID, RESET_ANSWERS } from './../store/stateReducer';

@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent implements OnInit {
  private state: any;
  private previousRoute: any;
  private id: String;
  private topRoutes = [
    '/garden',
    '/balcony',
    '/houseplant',
    '/bonsai',
    '/agriculture',
    '/verticalGreening',
    '/sensors',
    '/roofGreening'
  ];

  constructor(private store: Store<any>, private router: Router) {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: any) => {
        this.store.dispatch({
          type: UPDATE_ROUTES,
          payload: { active: event.url, previous: this.previousRoute }
        });
        this.previousRoute = event.url;
        if (this.isStartUrl(event.url)) {
          this.sendAnswersToServer();
        }
        this.erasePreviousAnswers();
        this.syncStoreWithLocalstorage();
      });
  }

  ngOnInit() {
    this.store
      .select(state => state.stateReducer)
      .subscribe(state => (this.state = state));

    this.syncStoreWithLocalstorage();
    if (this.state.id === '') {
      this.saveIdInStore(this.generateNewId());
    }
  }

  private erasePreviousAnswers() {
    if (!this.isTopRoute(this.state.routes.active)) {
      this.store.dispatch({
        type: RESET_ANSWERS,
        payload: {
          area: this.state.routes.active.substr(
            1,
            this.state.routes.active.length - 4
          ),
          question: this.state.routes.active.substr(
            this.state.routes.active.length - 2,
            this.state.routes.active.length
          )
        }
      });
    }
  }

  private isTopRoute(route) {
    if (this.topRoutes.indexOf(route) > -1) {
      return true;
    }
  }

  private syncStoreWithLocalstorage() {
    localStorage.setItem('redux', JSON.stringify(this.state));
  }

  private isStartUrl(url) {
    const startUrl = '/start';
    if (url === startUrl) {
      return false;
    } else {
      return true;
    }
  }

  private isIdInLocaleStorage() {
    if (this.state.id === '') {
      return false;
    } else {
      return true;
    }
  }

  private generateNewId() {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    for (let i = 0; i < 21; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  private saveIdInStore(id) {
    this.store.dispatch({ type: SAVE_ID, payload: id });
  }

  private async sendAnswersToServer() {
    // this.postJson();
    // console.log('sending mock');
  }

  private async postJson(): Promise<any> {
    const result = await fetch(
      'https://dev.kokkonias.de/OASJdoAJMFGOA2lomasoD242ASDo234oaseoqaJOsdgjosa',
      {
        method: 'post',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state)
      }
    )
      .then(res => res.json())
      .then(res => {
        // console.log(res);
      });
  }
}



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/title-bar/title-bar.component.ts